<h1 mat-dialog-title>{{data.title}}</h1>
<mat-dialog-content>
  {{data.message}}
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>Annuleren</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial *ngIf="!data.hideConfirm">Bevestigen</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial *ngIf="data.showRefreshButton" (click)="reloadCurrentPage()">Pagina verversen</button>
</mat-dialog-actions>
